import styled from "styled-components";

import { Lock as LockIcon } from '@material-ui/icons';

import {MaterialSelector} from "components/Selector";

export const InputContainer = styled.div`
  margin-bottom: 0.5rem;
  font-size: 16px;
`

export const StyledMaterialSelector = styled(MaterialSelector)`
  padding-right: 2rem !important;
`

export const PriceDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
`

export const TotalPriceDetail = styled(PriceDetail)`
  margin-top: 0.5rem;
  padding: 0.5rem 0;
  box-sizing: border-box;
  font-size: 1.25rem;
  font-weight: 600;
  border-top: solid 1px rgba(0, 0, 0, 0.12); 
  border-bottom: solid 1px rgba(0, 0, 0, 0.12); 
`

export const SectionTitle = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-size: 16px;
`

export const UpdateLink = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #0B4598;
`

export const UpdateLocationLink = styled(UpdateLink)`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 0;
`

export const CreditCardInfoContainer = styled.div`
  margin-top: 1.5rem;
  padding: 0.5rem 0;
  box-sizing: border-box;
  border-top: solid 1px rgba(0, 0, 0, 0.12);
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
`

export const CreditCardInfoTitle = styled.div`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 0.5rem;
`

export const CreditCardInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CreditCardNumber = styled.div`
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
`

export const InfoMessageContainer = styled.div`
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const InfoMessage = styled.div`
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.6);
`

export const StyledLockIcon = styled(LockIcon)`
  margin-right: 0.5rem;
  color: var(--primary-main, #FB7672);
  height: 1rem;
`

export const ErrorMessage = styled.div`
  color: var(--error-main, #D32F2F);
  margin-bottom: 1rem;
  text-align: center;
`
